import {  Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import {  Select              } from 'src/app/interface/select/select';
import {  Organization        } from 'src/app/beans/organization/organization.bean';
import {  LoadingManager      } from 'src/app/managers/loading/loading.manager';
import {  HandlerManager      } from 'src/app/managers/handler/handler.manager';
import {  SessionManager      } from 'src/app/managers/session/session.manager';
import {  User                } from 'src/app/beans/login/user/user.bean';
import {  Site                } from 'src/app/beans/site/site.bean';
import {  MatSelectChange     } from '@angular/material/select';

@Component({
  selector: 'site-select',
  templateUrl: './site.select.html',
  styleUrls: ['./site.select.scss']
})
export class SiteSelect implements OnInit, Select {

  @Input('org') set _organization(organization: Organization)
  {
    if(organization) this.init(organization.id)
  }

  @Input() autoSelectFirst: boolean = false
  @Input() enabled        : number  = 1

  @Output() change: EventEmitter<Site> = new EventEmitter<Site>()

  values      : Site[]
  currentValue: Site

  constructor(
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
  ) { }

  ngOnInit()
  {
    setInterval(async () => await this.checkRefresh(), 100)
  }

  async checkRefresh()
  {
    if(localStorage.getItem('site-select-refresh') == "1")
    {
      localStorage.setItem('site-select-refresh', "0")
      await this.init(this._organization.id)
    }
  }

  async init(organizationId: number)
  {
    await this.retriveValues(organizationId)

    if(this.setSavedValue(JSON.parse(localStorage.getItem('site-select')))) {}
    else if (this.autoSelectFirst) this.selectFirst()
  }

  getSelectedValue() {
    return this.currentValue
  }

  setSelectedValue(value: Site): void
  {
    this.currentValue = value
    this.change.emit(value)
  }

  clearSelectedValue(): void
  {
    this.setSelectedValue(undefined)
  }

  async retriveValues(organizationId: number)
  {
    const user  = this._session.user().get()

    if ( !User.isKind(user) ) return // TODO handle user incorrect

    this._loader.start()

    let response = await this._handler.site().list( (user as User).token, organizationId, this.enabled)

    this._loader.stop()

    if (!response) return

    const list = ( response as any ).list as Site[]

    this.values = list

    this.values.sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 0)

    return list
  }

  selectFirst (): void
  {
    if ( this.values && this.values.length > 0) {
      this.setSelectedValue(this.values[0])
    }
  }

  setSavedValue(site: Site)
  {
    var control = false
    if( this.values && site )
    {
      this.values.forEach(element => {
        if(element.id == site.id)
        { this.setSelectedValue(element)
          control = true
        }
      });
    }
    return control
  }

  selectElement(el: Site): void
  {
    const find = this.searchElement(el)
    if (find) this.setSelectedValue(find)
  }

  searchElement(el: Site): Site
  {
    if (!this.values) return undefined

    return this.values.find ( (org) => org.id == el.id )
  }

  refreshData(org: Organization)
  {
    this.init(org.id)
  }

  onChange(slChange: MatSelectChange)
  {
    this.setSelectedValue(slChange.value)
    localStorage.setItem('site-select', JSON.stringify(slChange.value))
  }
}
